import React from 'react';
import DOMPurify from 'dompurify';
import "../../../styles/article-database.css";

const ArticleDatabase = ({article}) => {
    return <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(article.Contenu)}}/>
}

export default ArticleDatabase;